import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Title from "../../common/Title"
import Loader from "../../common/Loader"
import { Button } from "../../common/Button"
import Message from "../../common/Message"
import InputField from "../../common/InputField"
import Select from "react-select"
import {
  onStartLoading,
  onCreateOrder,
  closeMessage,
  onGetStations,
  fetchAllStationData,
  onFetchExistOrders,
  getDeliveryDetailsFromIsraelPost,
  clearOrderUpdate,
  onCreateOrdersFromFile,
  clearCreateOrdersFromFile,
  fetchStationsByRole,
} from "../../../actions"
import { useNavigate } from "react-router-dom"

import "./style.scss"

const CreateNewOrderScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const INIT_STATE = {
    packageNumber: "",
    mobilePhone: "",
    firstName: "",
    lastName: "",
    externalOrderNumber: "",
    showLoading: false,
    stationsList: [],
    stationNumber: "",
    currentStationName: "",
    stationsFiltered: [],
    isShowCreateOrdersFail: false,
    isShowCreateOrdersSuccess: false,
    selectedStation: null,
    errorText: "",
    validField: {
      stationNumber: {
        type: "stationNumber",
        isRequired: true,
        isChecked: false,
        compareMinValue: 1,
        compareMaxValue: 10,
        isValid: false,
      },
      packageNumber: {
        type: "packageNumber",
        isRequired: true,
        isChecked: false,
        compareMinValue: 1,
        compareMaxValue: 30,
        isValid: false,
      },
      mobilePhone: {
        type: "mobile",
        isRequired: true,
        isChecked: false,
        isValid: false,
      },
      firstName: {
        type: "name",
        isRequired: true,
        isChecked: false,
        compareMinValue: 2,
        compareMaxValue: 30,
        isValid: false,
      },
      lastName: {
        type: "name",
        isRequired: true,
        isChecked: false,
        compareMinValue: 2,
        compareMaxValue: 30,
        isValid: false,
      },
      externalOrderNumber: {
        type: "externalOrderNumber",
        isRequired: true,
        isChecked: false,
        compareMinValue: 1,
        compareMaxValue: 30,
        isValid: false,
      },
    },
  }

  const [state, setState] = useState(INIT_STATE)

  const {
    authenticated,
    showMessage,
    isError,
    isLoadingNewOrder,
    orderList,
    stationsAll,
    stationsItemSelectList,
    israelPostDelivery,
    createOrdersFromFileSuccess,
    createOrdersFromFileFail,
    userData,
    createOrdersFromFileResponse,
    selectedDecathlonStation,
    stations,
  } = useSelector((state) => ({
    authenticated: state.users.authenticated,
    showMessage: state.orders.showMessage,
    isError: state.orders.isError,
    isLoadingNewOrder: state.orders.isLoadingNewOrder,
    orderList: state.orders.orderList,
    stationsAll: state.station.stationsAll,
    stationsItemSelectList: state.station.stationsItemSelectList,
    israelPostDelivery: state.israelPost.israelPostDelivery,
    createOrdersFromFileSuccess: state.orders.createOrdersFromFileSuccess,
    createOrdersFromFileFail: state.orders.createOrdersFromFileFail,
    userData: state.users.userData,
    createOrdersFromFileResponse: state.orders.createOrdersFromFileResponse,
    selectedDecathlonStation: state.station.selectedDecathlonStation,
    stations: state.station.stations,
  }))

  useEffect(() => {
    if (!authenticated) {
      navigate("/")
      return
    }

    dispatch(onGetStations())
    if (orderList && orderList.length === 0) {
      dispatch(onFetchExistOrders())
    }
  }, [authenticated, orderList, dispatch, navigate])

  useEffect(() => {
    if (israelPostDelivery) {
      populateUserFieldsByPackage()
    }
  }, [israelPostDelivery])

  useEffect(() => {
    if (stations?.length == 0) {
      dispatch(fetchStationsByRole())
    }
  }, [stations])

  useEffect(() => {
    if (stationsAll?.length > 0) {
      setState((prevState) => ({
        ...prevState,
        stationsList: [...stationsAll],
        currentStationName: stationsAll[0]?.stationName,
      }))
      if (stationsItemSelectList?.length === 0) {
        dispatch(fetchAllStationData(stationsAll))
      }
    }
  }, [stationsAll, stationsItemSelectList, dispatch])

  useEffect(() => {
    if (stationsItemSelectList.length === 1 && state.stationNumber === "") {
      setState((prevState) => ({
        ...prevState,
        stationNumber: stationsItemSelectList[0],
      }))
    }
  }, [stationsItemSelectList, state.stationNumber])

  useEffect(() => {
    if (createOrdersFromFileSuccess) {
      const failedOrders = checkForFailedOrders()
      setState((prevState) => ({
        ...prevState,
        failedOrdersList: failedOrders,
      }))
      generateResponseMsg(failedOrders)
    }
  }, [createOrdersFromFileSuccess])

  useEffect(() => {
    if (createOrdersFromFileFail) {
      //dispatch(clearCreateOrdersFromFile())
      setState((prevState) => ({
        ...prevState,
        isShowCreateOrdersFail: true,
      }))
    } else {
      setState((prevState) => ({
        ...prevState,
        isShowCreateOrdersFail: false,
      }))
    }
  }, [createOrdersFromFileFail, dispatch])

  useEffect(() => {
    if (stationsItemSelectList?.length > 0) {
      selectStationForDecathlon()
    }
  }, [stationsItemSelectList])

  const populateUserFieldsByPackage = () => {
    const { fName, lName, phone, stationNumber } = israelPostDelivery

    setState((prevState) => ({
      ...prevState,
      firstName: fName,
      lastName: lName,
      mobilePhone: phone,
      stationNumber: setDefaultStation(stationNumber),
    }))
  }

  const closeCreateOrdersPopup = () => {
    setState((prevState) => ({
      ...prevState,
      isShowCreateOrdersFail: false,
      isShowCreateOrdersSuccess: false,
    }))
    dispatch(clearCreateOrdersFromFile())
  }

  const checkForFailedOrders = () => {
    let failedOrdersList = []

    if (createOrdersFromFileResponse?.data.length > 0) {
      createOrdersFromFileResponse?.data.forEach((order) => {
        if (order.status === false) {
          failedOrdersList.push(order.packageNumber)
        }
      })
    }

    return failedOrdersList
  }

  const generateResponseMsg = (failedOrders) => {
    let msg = ""
    dispatch(clearCreateOrdersFromFile())

    if (failedOrders.length === 0) {
      setState((prevState) => ({
        ...prevState,
        isShowCreateOrdersSuccess: true,
      }))
      return
    }

    if (failedOrders.length === createOrdersFromFileResponse.data.length) {
      setState((prevState) => ({
        ...prevState,
        isShowCreateOrdersFail: true,
      }))
      return
    }

    if (failedOrders.length > 0) {
      msg = "ההזמנות הבאות נכשלו: "
      failedOrders.forEach((order) => {
        msg += order + ", "
      })
      msg = msg.substring(0, msg.length - 2)

      setState((prevState) => ({
        ...prevState,
        errorText: msg,
        isShowCreateOrdersSuccess: true,
      }))
      return
    }
  }

  const setDefaultStation = (stationNumber) => {
    if (stationsFiltered.length === 1) {
      return stationsFiltered[0]
    }
    const station = stationsFiltered.find(
      (option) => option.value === stationNumber
    )
    return station || stationNumber
  }

  const validateInputValue = (field, value) => {
    let isValid = false
    const fieldObj = state.validField[field]

    if (fieldObj) {
      if (fieldObj.isRequired && value.toString().trim() !== "") {
        isValid = true
      }

      setState((prevState) => ({
        ...prevState,
        validField: {
          ...prevState.validField,
          [field]: {
            ...prevState.validField[field],
            isChecked: true,
            isValid,
          },
        },
      }))
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    dispatch(onCreateOrdersFromFile(file))
  }

  const handleInputChange = (field, value) => {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }))
  }

  const handleStationChange = (station) => {
    setState((prevState) => ({
      ...prevState,
      stationNumber: station.value,
      selectedStation: station,
    }))
    validateInputValue("stationNumber", station.value)
  }

  const selectStationForDecathlon = () => {
    if (selectedDecathlonStation && stationsItemSelectList) {
      const result = stationsItemSelectList.find(
        (obj) => obj.value === selectedDecathlonStation
      )
      validateInputValue("stationNumber", stationNumber)
      if (result) {
        setState((prevState) => ({
          ...prevState,
          stationsFiltered: [result],
          selectedStation: result,
          stationNumber: result.value,
        }))

        return
      }
    }
    setState((prevState) => ({
      ...prevState,
      stationsFiltered: stationsItemSelectList,
    }))
  }

  const isValidForm = (order) => {
    const updatedValidField = { ...state.validField }
    let allValid = true

    const fieldsToCheck = [
      { key: "stationNumber", value: order.stationNumber },
      { key: "packageNumber", value: order.packageNumber },
      { key: "mobilePhone", value: order.mobilePhone },
      { key: "firstName", value: order.firstName },
      { key: "lastName", value: order.lastName },
    ]

    fieldsToCheck.forEach(({ key, value }) => {
      const fieldObj = state.validField[key]
      let isValid = false

      if (fieldObj?.isRequired && value.toString().trim() !== "") {
        isValid = true
      }

      updatedValidField[key] = {
        ...fieldObj,
        isChecked: true,
        isValid,
      }

      if (!isValid) {
        allValid = false
      }
    })

    setState((prevState) => ({
      ...prevState,
      validField: updatedValidField,
    }))

    return allValid
  }

  const {
    validField,
    stationNumber,
    packageNumber,
    mobilePhone,
    firstName,
    lastName,
    externalOrderNumber,
    stationsFiltered,
    isShowCreateOrdersSuccess,
    isShowCreateOrdersFail,
    errorText,
    selectedStation,
  } = state

  if (isLoadingNewOrder) {
    return (
      <div>
        <Title text="יצירת הזמנה חדשה" />
        <Loader show={true} />
      </div>
    )
  }

  const onClickCreateOrder = () => {
    const {
      stationNumber,
      packageNumber,
      mobilePhone,
      firstName,
      lastName,
      externalOrderNumber,
    } = state

    const resolvedStationNumber =
      userData?.orderTypeGroup === "4" ? 1000 : stationNumber

    if (
      !isValidForm({
        stationNumber: resolvedStationNumber,
        packageNumber,
        mobilePhone,
        firstName,
        lastName,
        externalOrderNumber,
      })
    ) {
      return
    }
    dispatch(clearOrderUpdate())
    dispatch(
      onCreateOrder(
        resolvedStationNumber,
        packageNumber,
        mobilePhone,
        firstName,
        lastName,
        externalOrderNumber
      )
    )
  }

  const onMessageClickOk = () => {
    if (isError) {
      dispatch(closeMessage())
      return
    }

    dispatch(closeMessage())
    clearForm()
  }

  const clearForm = () => {
    setState((prevState) => ({
      ...prevState,
      stationNumber: "",
      packageNumber: "",
      mobilePhone: "",
      firstName: "",
      lastName: "",
      externalOrderNumber: "",
    }))
  }

  return (
    <div className="create-order">
      <Title text="יצירת הזמנה חדשה" />
      <InputField
        isFocused={true}
        show={true}
        value={packageNumber}
        placeholder="מספר חבילה"
        mandatory={true}
        showValidation={validField.packageNumber.isChecked}
        showValidationOk={validField.packageNumber.isValid}
        showValidationError={!validField.packageNumber.isValid}
        validationErrorMessage="מספר חבילה לא תקין"
        onFocus={(e) => handleInputChange("packageNumber", e.target.value)}
        onBlur={(e) => validateInputValue("packageNumber", e.target.value)}
        onChange={(e) => handleInputChange("packageNumber", e.target.value)}
        maxLength={30}
      />
      <InputField
        show={true}
        value={mobilePhone}
        placeholder="מספר טלפון"
        mandatory={true}
        showValidation={validField.mobilePhone.isChecked}
        showValidationOk={validField.mobilePhone.isValid}
        showValidationError={!validField.mobilePhone.isValid}
        validationErrorMessage="מספר טלפון לא תקין"
        onFocus={(e) => handleInputChange("mobilePhone", e.target.value)}
        onBlur={(e) => validateInputValue("mobilePhone", e.target.value)}
        onChange={(e) => handleInputChange("mobilePhone", e.target.value)}
        maxLength={10}
      />
      <InputField
        show={true}
        value={firstName}
        iconStyle=""
        placeholder="שם פרטי"
        mandatory={true}
        showValidation={validField.firstName.isChecked}
        showValidationOk={validField.firstName.isValid}
        showValidationError={!validField.firstName.isValid}
        validationErrorMessage="שם פרטי לא תקין"
        onFocus={(e) => handleInputChange("firstName", e.target.value)}
        onBlur={(e) => validateInputValue("firstName", e.target.value)}
        onChange={(e) => handleInputChange("firstName", e.target.value)}
        maxLength={30}
      />
      <InputField
        show={true}
        value={lastName}
        iconStyle=""
        placeholder="שם משפחה"
        mandatory={true}
        showValidation={validField.lastName.isChecked}
        showValidationOk={validField.lastName.isValid}
        showValidationError={!validField.lastName.isValid}
        validationErrorMessage="שם משפחה לא תקין"
        onFocus={(e) => handleInputChange("lastName", e.target.value)}
        onBlur={(e) => validateInputValue("lastName", e.target.value)}
        onChange={(e) => handleInputChange("lastName", e.target.value)}
        maxLength={30}
      />
      {userData?.role === "DHL" && (
        <InputField
          show={true}
          value={externalOrderNumber}
          iconStyle=""
          placeholder="pieceId"
          mandatory={true}
          showValidation={validField.externalOrderNumber.isChecked}
          showValidationOk={validField.externalOrderNumber.isValid}
          showValidationError={!validField.externalOrderNumber.isValid}
          validationErrorMessage="pieceId לא תקין"
          onFocus={(e) =>
            handleInputChange("externalOrderNumber", e.target.value)
          }
          onBlur={(e) =>
            validateInputValue("externalOrderNumber", e.target.value)
          }
          onChange={(e) =>
            handleInputChange("externalOrderNumber", e.target.value)
          }
          maxLength={30}
        />
      )}

      {userData?.orderTypeGroup !== "4" && (
        <div>
          <Select
            value={selectedStation}
            className="station-selector"
            placeholder="עמדה"
            options={stationsFiltered}
            onChange={(stn) => handleStationChange(stn)}
          />
          {validField.stationNumber.isChecked &&
          !validField.stationNumber.isValid ? (
            <div className="station-number-error">
              <span className="fa fa-times-circle"></span>
              <span>אנא בחר עמדה</span>
            </div>
          ) : null}
        </div>
      )}

      <div className="buttons-wrapper">
        <Button onClick={() => onClickCreateOrder()}>צור הזמנה</Button>
        {userData?.orderTypeGroup === "2" && (
          <div>
            <label
              className="fileInputButton"
              onChange={(e) => handleFileChange(e)}
              htmlFor="ordersFile"
            >
              <input name="" type="file" id="ordersFile" hidden />
              טען קובץ
            </label>
            {isLoadingNewOrder && "LoadingIndicator..."}
          </div>
        )}
        <Button extraClass="back" onClick={() => navigate(-1)}>
          חזור
        </Button>
      </div>

      <Message
        show={showMessage}
        isError={isError}
        successText="ההזמנה הוספה בהצלחה"
        errorText="הוספת הזמנה נכשלה"
        onClick={(e) => onMessageClickOk(e)}
      />
      <Message
        show={isShowCreateOrdersSuccess}
        isError={isError}
        successText={`הזמנות נוספו בהצלחה ${
          errorText ? <div className="failed-orders">{errorText}</div> : ""
        }`}
        errorText=""
        onClick={() => closeCreateOrdersPopup()}
      />
      <Message
        show={isShowCreateOrdersFail}
        isError={true}
        successText=""
        errorText=" הוספת הזמנה נכשלה"
        onClick={() => closeCreateOrdersPopup()}
      />
    </div>
  )
}

export default CreateNewOrderScreen
